import React from "react";
import { withStyles } from "@material-ui/core";
import { get, filter, map, join } from "lodash";

import Grid from "@material-ui/core/Grid";

import SchedulerOccurrenceView from "../SchedulerOccurrenceView/SchedulerOccurrenceView";

import { displayData } from "../../../utils/data";
import { darkenColor } from "../../../utils/color";
import { getAttributeValue } from "../../../utils/profile";
import { getOccurrenceArrival } from "../../../utils/scheduler";

import colors from "../../../assets/style/colors";
import EllipsedTextNew from "../../Common/EllipsedTextNew";
import images from "../../../assets/img/images";

const styles = {
  container: {
    height: "30px",
    boxSizing: "border-box",
    padding: "3px",
    marginBottom: "2px",
    cursor: "pointer",
  },
  dataItem: {
    color: colors.black87,
    fontSize: "1em",
    height: "14px",
    lineHeight: "16px",
  },
};

const SchedulerOccurrenceDaily = (props) => {
  const { classes, group, columnsWidth, timeSlots, refresh } = props;
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [del,  setDel] = React.useState(false);

  const occurrenceStart = getOccurrenceArrival(group);

  const hostProfile = get(
    filter(
      get(occurrenceStart, ["profiles"]),
      (p) => get(p, ["association_type", "id"]) === 1
    ),
    [0, "profile"]
  );

  function MouseOver(event) {
    var id = event.target.id;
    var allContainers = document.querySelectorAll('[name^="muigridcontainer"]')
    var allContainers_round = document.querySelectorAll('[name^="roundicon"]')

    for (var i=0;i<allContainers.length;i++){
      if (allContainers[i]["id"] === id){
        allContainers[i].style.outline = "0.5px solid #5f00a0"
        allContainers[i].style.outlineOffset = "-0.5px"
        allContainers[i].style.borderLeft = `3px solid ${zoneColor}`
      }
    }

    for (i=0;i<allContainers_round.length;i++){
      if (allContainers_round[i]["id"] === id+"round"){
        allContainers_round[i].style.visibility = "visible"
      }
    }
  }
  function MouseOut(event){
    var id = event.target.id;
    var allContainers = document.querySelectorAll('[name^="muigridcontainer"]')
    var allContainers_round = document.querySelectorAll('[name^="roundicon"]')

    for (var i=0;i<allContainers.length;i++){
      if (allContainers[i]["id"] === id){
        allContainers[i].style.outline = "none"
        allContainers[i].style.outlineOffset = "-0.5px"
        allContainers[i].style.borderLeft = `3px solid ${zoneColor}`
      }
    }

    for (i=0;i<allContainers_round.length;i++){
      if (allContainers_round[i]["id"] === id+"round"){
        allContainers_round[i].style.visibility = "hidden"
      }
    }
  }
  

  const zoneColor =
    get(occurrenceStart, ["zones", 0, "zone", "color", "rgb"]) ||
    get(occurrenceStart, ["zones", 0, "zone", "type", "color", "rgb"]);

  

  return (
    <Grid
      item
      data-test="scheduler-occurrence-component"
      className={classes.container}
      onClick={() => setOpen(true)}
      onMouseOver={MouseOver}
      onMouseOut={MouseOut}
      name="muigridcontainer"
      id={occurrenceStart["id"]}
      style={{
        backgroundColor: `#${zoneColor}`,
        border: zoneColor ? "none" : `1px solid ${colors.black}`,
        borderLeft: `3px solid ${darkenColor(zoneColor)}`,
      }}
    >
      {open && (
        <SchedulerOccurrenceView
          open={open}
          setOpen={setOpen}
          occurrence={group}
          timeSlots={timeSlots}
          refresh={refresh}
          customTimeSlot={false}
          edit={edit}
          del={del}
        />
      )}
      <Grid container alignItems="center" className="height-100" id={occurrenceStart["id"]}>
        <Grid
          item
          id={occurrenceStart["id"]}
          className={classes.dataItem}
          style={{ width: get(columnsWidth, [0]) }}
          data-test="scheduler-occurrence-name"
        >
          {`${get(hostProfile, ["firstname"])} ${get(hostProfile, [
            "lastname",
          ])}`}

        </Grid>
        <Grid
          item
          id={occurrenceStart["id"]}
          className={classes.dataItem}
          style={{ width: get(columnsWidth, [1]) }}
          data-test="scheduler-occurrence-unit"
        >
          {get(occurrenceStart, ["zones", 0, "zone", "name"])}
        </Grid>
        <Grid
          item
          id={occurrenceStart["id"]}
          className={classes.dataItem}
          style={{ width: get(columnsWidth, [2]) }}
          data-test="scheduler-occurrence-visitors"
        >
          <EllipsedTextNew
            id={occurrenceStart["id"]}
            text={join(
              map(
                filter(
                  get(occurrenceStart, ["profiles"]),
                  (p) => get(p, ["association_type", "id"]) === 2
                ),
                (p) =>
                  `${get(p, ["profile", "firstname"])} ${get(p, [
                    "profile",
                    "lastname",
                  ])}`
              ),
              [", "]
            )}
            maxWidth={get(columnsWidth, [2]) - 10}
          />
        </Grid>
        <Grid
          item
          xs
          className={classes.dataItem}
          id={occurrenceStart["id"]}
          data-test="scheduler-occurrence-notes"
          style={{ maxWidth: "-webkit-fill-available", overflow: "hidden" }}
        >
          <EllipsedTextNew
          
            text={displayData(getAttributeValue(occurrenceStart, 19))}
            maxWidth={"100%"}
          />

        </Grid>
        <Grid item name="roundicon" className={classes.iconItem} id={occurrenceStart["id"]+"round"} style={{position: "relative", transform: "translateX(50%)", visibility:"hidden", height:"0px"}}>
            <img src={images.round} id={occurrenceStart["id"]} alt="round_icon" style={{position: "relative", float: "right", top:"-24px"}} onClick={() => { setEdit(true); setDel(false); setOpen(true)}}/>
          </Grid>
      </Grid>

    </Grid>
  );
};

export default withStyles(styles)(SchedulerOccurrenceDaily);
